/**
 * Noms de familles = clés passées à `useFonts` / `fontFamily` (sans espace, alignés sur les fichiers .otf).
 */
export const TheFutureFonts = {
  black: 'TheFuture-Black',
  blackItalic: 'TheFuture-BlackItalic',
  bold: 'TheFuture-Bold',
  boldItalic: 'TheFuture-BoldItalic',
  italic: 'TheFuture-Italic',
  light: 'TheFuture-Light',
  lightItalic: 'TheFuture-LightItalic',
  medium: 'TheFuture-Medium',
  mediumItalic: 'TheFuture-MediumItalic',
  regular: 'TheFuture-Regular',
} as const;

export const InterFonts = {
  black: 'Inter',
  blackItalic: 'Inter-Italic',
  bold: 'Inter',
  boldItalic: 'Inter-Italic',
  italic: 'Inter-Italic',
  light: 'Inter',
  lightItalic: 'Inter-Italic',
  medium: 'Inter',
  mediumItalic: 'Inter-Italic',
  regular: 'Inter',
} as const;

/** Carte pour `useFonts` — une entrée par fichier. */
export const THE_FUTURE_FONT_LOAD_MAP = {
  [TheFutureFonts.black]: require('../../../assets/fonts/TheFuture-Black.otf'),
  [TheFutureFonts.blackItalic]: require('../../../assets/fonts/TheFuture-BlackItalic.otf'),
  [TheFutureFonts.bold]: require('../../../assets/fonts/TheFuture-Bold.otf'),
  [TheFutureFonts.boldItalic]: require('../../../assets/fonts/TheFuture-BoldItalic.otf'),
  [TheFutureFonts.italic]: require('../../../assets/fonts/TheFuture-Italic.otf'),
  [TheFutureFonts.light]: require('../../../assets/fonts/TheFuture-Light.otf'),
  [TheFutureFonts.lightItalic]: require('../../../assets/fonts/TheFuture-LightItalic.otf'),
  [TheFutureFonts.medium]: require('../../../assets/fonts/TheFuture-Medium.otf'),
  [TheFutureFonts.mediumItalic]: require('../../../assets/fonts/TheFuture-MediumItalic.otf'),
  [TheFutureFonts.regular]: require('../../../assets/fonts/TheFuture-Regular.otf'),
} as const;

// export const INTER_FONT_LOAD_MAP = {
//   [InterFonts.black]: require('../../../assets/fonts/Inter-Black.otf'),
//   [InterFonts.blackItalic]: require('../../../assets/fonts/Inter-BlackItalic.otf'),
//   [InterFonts.bold]: require('../../../assets/fonts/Inter-Bold.otf'),
//   [InterFonts.boldItalic]: require('../../../assets/fonts/Inter-BoldItalic.otf'),
//   [InterFonts.italic]: require('../../../assets/fonts/Inter-Italic.otf'),
//   [InterFonts.light]: require('../../../assets/fonts/Inter-Light.otf'),
//   [InterFonts.lightItalic]: require('../../../assets/fonts/Inter-LightItalic.otf'),
//   [InterFonts.medium]: require('../../../assets/fonts/Inter-Medium.otf'),
//   [InterFonts.mediumItalic]: require('../../../assets/fonts/Inter-MediumItalic.otf'),
//   [InterFonts.regular]: require('../../../assets/fonts/Inter-Regular.otf'),
// } as const;
